export default "__VITE_ASSET__DwgQBs1P__"